export default __webpack_public_path__ + "static/header-mob-6c0c0d501f8b02dd7d20447fa64dabec.png";